import verifyLabel from '../../../methods/verifyLabel'

export default {
    name: 'related-product',
    data(){
        return {
           
        }
    },
    computed:{
        data() {
            return this.$store.state.main.relatedCollectionBanner
        },
        labels() {
            return this.$store.state.main.labels
        }
    },
    methods: {
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName,this.$store.state.main.labels)
            } else {
                return ""
            }
        }
    }
}